import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from "react-table";
import { useMemo } from "react";
import GlobalFilter from "./global-filter";
import TableHeader from "./table-header";
import TableBody from "./table-body";
import TablePagination from "./table-pagination";
import ActionDropDown from "./action-drop-down";
import { useTranslation } from "react-i18next";
import ManualTablePagination from "./manual-table-pagination";
type Columns = {
  Header: string;
  accessor: string;
};
type TableAction = {
  title: string;
  action?: any;
  active?: boolean;
  icon?: JSX.Element;
};
type PropsType = {
  fillPage?: boolean;
  columns: Columns[];
  defaultSortKey?: string;
  data: object[];
  hideheader?: boolean;
  hideAction?: boolean;
  tableAction?: TableAction[];
  query?: any;
  filterKeys?: any;
  setFilterKeys?: any;
  mutate?: any;
  filterModal?: any;
  defaultHiddenColumns?: string[];
  totalPages?: number;
  next?: any;
  previous?: any;
  defaultPageSize?: number;
  manualPageination?: boolean;
  goToPage?: (currentpage: number) => void;
  searchBar?: boolean;
  crntpage?: number;
  backgroundColor?: any;
  minHeights?: any;
  withFilter?: boolean;
};
const Table: React.FC<PropsType> = ({
  columns,
  data,
  hideheader = false,
  hideAction = false,
  tableAction,
  fillPage = false,
  defaultHiddenColumns = [],
  totalPages,
  previous,
  next,
  defaultPageSize = 50,
  manualPageination = false,
  goToPage,
  crntpage,
  searchBar = true,
  backgroundColor = "bg-white",
  minHeights = "5rem",
  withFilter = false,
}) => {
  const { t, i18n } = useTranslation();
  const tableHooks = (hooks: any) => {
    if (hideAction) {
      return;
    } else {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: "action",
          Header: t("action"),
          Cell: ({ row, render }) => {
            return <ActionDropDown row={row} tableAction={tableAction || []} />;
          },

          zIndex: 0,
        },
      ]);
    }
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    setGlobalFilter,
    nextPage,
    previousPage,
    gotoPage,
    pageCount,
    setPageSize,
    canNextPage,
    pageOptions,
    canPreviousPage,
    prepareRow,
  } = useTable(
    {
      columns: useMemo(() => columns, [columns]),
      data: useMemo(() => data, [data]),
      initialState: {
        pageIndex: 0,
        hiddenColumns: defaultHiddenColumns,
        pageSize: defaultPageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,

    tableHooks
  );
  const { globalFilter, pageIndex, pageSize } = state;
  return (
    <div className="w-full h-full">
      {searchBar === true ? (
        <>
          <div className={"w-[500px] mb-5"}>
            <GlobalFilter
              filter={globalFilter}
              setFilter={setGlobalFilter}
              i18n={i18n}
            />
          </div>
        </>
      ) : (
        ""
      )}
      <div className="bg-white rounded-t-md">
        <div
          style={
            fillPage
              ? {
                  maxHeight: withFilter
                    ? `calc(100vh - 260px )`
                    : `calc(100vh - 215px )`,
                  minHeight: withFilter
                    ? `calc(100vh - 260px )`
                    : `calc(100vh - 215px )`,
                }
              : {}
          }
          className={`w-full  ${
            fillPage
              ? "overflow-y-scroll hidehorizontalScroll show-scroll-bar overflow-x-auto form-wrap"
              : "overflow-x-auto"
          }  my-2   bg-white rounded-md ${backgroundColor}`}
        >
          <div
            style={fillPage ? {} : { minHeight: minHeights }}
            className="w-full "
          >
            <table {...getTableProps()} className="w-full ">
              {!hideheader && (
                <TableHeader fillPage={fillPage} headerGroups={headerGroups} />
              )}
              <TableBody
                page={page}
                prepareRow={prepareRow}
                getTableBodyProps={getTableBodyProps}
              />
            </table>
          </div>
          {!fillPage && (
            <div>
              {manualPageination ? (
                <ManualTablePagination
                  fillPage={false}
                  totalPages={totalPages}
                  goToPage={goToPage}
                  pageSize={defaultPageSize ?? 50}
                  t={t}
                  crntpage={crntpage}
                />
              ) : (
                <TablePagination
                  fillPage={false}
                  previousPage={previousPage}
                  canPreviousPage={canPreviousPage}
                  gotoPage={gotoPage}
                  pageIndex={pageIndex}
                  pageOptions={pageOptions}
                  canNextPage={canNextPage}
                  nextPage={nextPage}
                  pageCount={pageCount}
                  setPageSize={setPageSize}
                  pageSize={pageSize}
                  t={t}
                  totalPages={totalPages}
                  next={next}
                  previous={previous}
                  data={data}
                />
              )}
            </div>
          )}
        </div>
        {fillPage && (
          <div className="px-4 bg-white rounded-b-md show-scroll-bar form-wrap">
            {manualPageination ? (
              <ManualTablePagination
                fillPage={true}
                totalPages={totalPages}
                goToPage={goToPage}
                pageSize={defaultPageSize ?? 50}
                t={t}
                crntpage={crntpage}
              />
            ) : (
              <TablePagination
                fillPage={true}
                previousPage={previousPage}
                canPreviousPage={canPreviousPage}
                gotoPage={gotoPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                canNextPage={canNextPage}
                nextPage={nextPage}
                pageCount={pageCount}
                setPageSize={setPageSize}
                pageSize={pageSize}
                t={t}
                totalPages={totalPages}
                next={next}
                previous={previous}
                data={data}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default Table;
